<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.BaseConverter.title') }}</span>
      <span class="fmt-spacer"/>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <div class="bc-grid">
      <div v-for="b in bases" :key="b.key" :class="['bc-card',{active:activeFrom===b.key}]">
        <div class="bc-card-hd">
          <span class="bc-card-label">{{ baseLabels[b.key] }}</span>
          <span class="bc-card-base">{{ b.base }}</span>
        </div>
        <input class="bc-input" v-model="values[b.key]" :placeholder="basePlaceholders[b.key]"
          @input="convert(b.key)" @focus="activeFrom=b.key" spellcheck="false"/>
        <button class="bc-copy" @click="copyVal(b.key)" title="复制">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
        </button>
      </div>
    </div>
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning"/> {{ errorMsg }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.BaseConverter.hint') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'BaseConverterTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return {
      values:{bin:'',oct:'',dec:'',hex:''},activeFrom:'',errorMsg:'',
      bases:[
        {key:'dec',base:'10'},{key:'hex',base:'16'},{key:'bin',base:'2'},{key:'oct',base:'8'}
      ]
    }
  },
  computed:{
    baseLabels(){ var t=this; return { dec:t.$t('tool.BaseConverter.dec'), hex:t.$t('tool.BaseConverter.hex'), bin:t.$t('tool.BaseConverter.bin'), oct:t.$t('tool.BaseConverter.oct') } },
    basePlaceholders(){ var t=this; return { dec:t.$t('tool.BaseConverter.phDec'), hex:t.$t('tool.BaseConverter.phHex'), bin:t.$t('tool.BaseConverter.phBin'), oct:t.$t('tool.BaseConverter.phOct') } }
  },
  methods:{
    convert:function(from){
      this.activeFrom=from;this.errorMsg=''
      var v=this.values[from].trim()
      if(!v){this._clearOthers(from);return}
      try{
        var radix={bin:2,oct:8,dec:10,hex:16}
        var num=parseInt(v.replace(/[^0-9a-fA-F]/g,''),radix[from])
        if(isNaN(num)){this._clearOthers(from);this.errorMsg=this.$t('tool.BaseConverter.errInvalid',{radix:radix[from]});return}
        this.values.bin=num.toString(2)
        this.values.oct=num.toString(8)
        this.values.dec=String(num)
        this.values.hex=num.toString(16).toUpperCase()
      }catch(e){this.errorMsg=this.$t('tool.BaseConverter.errConvert')}
    },
    _clearOthers:function(from){
      var self=this
      Object.keys(this.values).forEach(function(k){if(k!==from)self.values[k]=''})
    },
    copyVal:function(key){
      var v=this.values[key]
      if(!v){this.$message.warning(this.$t("common.status.noContent"));return}
      navigator.clipboard.writeText(v);this.$message.success(this.$t("common.status.copied"))
    },
    clearAll:function(){
      var self=this
      Object.keys(this.values).forEach(function(k){self.values[k]=''})
      this.activeFrom='';this.errorMsg=''
    },
    doAction:function(a){if(a==='clear')this.clearAll()}
  }
}
</script>

<style scoped>
.fmt-tool{display:flex;flex-direction:column;gap:12px;max-width:100%}

.fmt-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.fmt-toolbar >>> .el-button + .el-button{margin-left:0}
.fmt-label{font-size:13px;font-weight:700;color:#1a1f36}
.fmt-spacer{flex:1}

.bc-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:12px}
.bc-card{background:#fafbfc;border:2px solid #ebeef5;border-radius:12px;padding:16px 18px;display:flex;align-items:center;gap:10px;transition:.15s;position:relative}
.bc-card.active{border-color:#4e7cff;background:#f8faff;box-shadow:0 0 0 4px rgba(78,124,255,.04)}
.bc-card-hd{display:flex;flex-direction:column;gap:2px;min-width:60px;flex-shrink:0}
.bc-card-label{font-size:13px;font-weight:700;color:#303133}
.bc-card-base{font-size:10px;color:#b0b8c4;font-family:monospace}
.bc-input{flex:1;min-width:0;border:none;outline:none;background:transparent;font-size:18px;font-family:'SF Mono',Menlo,Consolas,monospace;color:#1a1f36;padding:4px 0;text-align:right}
.bc-input::placeholder{color:#d0d4dc;font-size:14px}
.bc-copy{display:flex;align-items:center;justify-content:center;width:28px;height:28px;border:none;border-radius:6px;cursor:pointer;background:transparent;color:#c0c8d4;transition:.12s;flex-shrink:0}
.bc-copy:hover{background:#f0f4ff;color:#4e7cff}

.fmt-status-bar{font-size:12px}
.fmt-err{color:#f56c6c;display:flex;align-items:center;gap:4px}
.fmt-hint{color:#c0c4cc}

@media(max-width:480px){.bc-grid{grid-template-columns:1fr}}
</style>
